import { useParams } from 'react-router-dom'
import { WorkflowBuilderPage } from 'app/components/workflows/WorkflowBuilderPage'
import { WorkflowsGate } from 'app/components/workflows/WorkflowsGate'

export const handle = {
  title: `Workflow`,
  breadcrumb: `Workflow`,
}

export default function WorkflowsEditView() {
  const { workflowId } = useParams()
  return (
    <WorkflowsGate>
      <WorkflowBuilderPage mode="edit" workflowId={workflowId} />
    </WorkflowsGate>
  )
}
